import { StyleSheet } from 'react-native'

import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

export default StyleSheet.create({
  primaryButtonStyle: theme => ({
    alignItems: 'center',
    backgroundColor: theme.colors.buttons.primary.default,
    borderRadius: 6,
    height: 44,
    justifyContent: 'center',
  }),
  primaryTextStyle: theme => ({
    color: theme.colors.textButtons.primary.default,
    fontSize: 18,
    textAlign: 'center',
  }),
  secondaryButtonStyle: theme => ({
    alignItems: 'center',
    backgroundColor: theme.colors.buttons.secondary.default,
    borderColor: Colors.brownGrey,
    borderWidth: 1,
    borderRadius: 6,
    height: 44,
    justifyContent: 'center',
  }),
  secondaryTextStyle: theme => ({
    color: theme.colors.textButtons.secondary.default,
    fontSize: 18,
    textAlign: 'center',
  }),
  tertiaryButtonStyle: theme => ({
    alignItems: 'center',
    backgroundColor: theme.colors.buttons.tertiary.default,
    borderRadius: 6,
    borderColor: Colors.light_grey,
    borderWidth: 1,
    height: 44,
    justifyContent: 'center',
  }),
  tertiaryTextStyle: theme => ({
    color: theme.colors.textButtons.tertiary.default,
    fontSize: 18,
    textAlign: 'center',
  }),
  quaternaryButtonStyle: theme => ({
    alignItems: 'center',
    backgroundColor: theme.colors.buttons.quaternary.default,
    borderColor: theme.colors.buttons.quaternary.borderColor,
    borderWidth: 1,
    borderRadius: 6,
    height: 44,
    justifyContent: 'center',
  }),
  quaternaryTextStyle: theme => ({
    color: theme.colors.textButtons.quaternary.default,
    fontSize: 18,
    textAlign: 'center',
  }),
  fallButtonStyle: theme => ({
    alignItems: 'center',
    backgroundColor: Colors.blackRGBA(0.1),
    borderRadius: 6,
    height: 44,
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: Colors.white,
  }),
  fallTextStyle: theme => ({
    color: Colors.white,
    fontSize: 18,
    textAlign: 'center',
  }),
  winterButtonStyle: theme => ({
    alignItems: 'center',
    backgroundColor: 'rgba(24, 138, 180, 0.9)',
    borderRadius: 6,
    height: 44,
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: Colors.white,
  }),
  winterTextStyle: theme => ({
    color: Colors.white,
    fontSize: 18,
    textAlign: 'center',
  }),
  lightButtonStyle: theme => ({
    alignItems: 'center',
    backgroundColor: Colors.white,
    borderRadius: 6,
    height: 44,
    justifyContent: 'center',
  }),
  lightTextStyle: theme => ({
    color: Colors.vfRed,
    fontSize: 18,
    textAlign: 'center',
  }),
  darkButtonStyle: theme => ({
    alignItems: 'center',
    backgroundColor: Colors.smoothGrey,
    borderRadius: 6,
    height: 44,
    justifyContent: 'center',
  }),
  darkTextStyle: theme => ({
    color: Colors.white,
    fontSize: 18,
    textAlign: 'center',
  }),

  disabledButtonStyle: {
    backgroundColor: Colors.veryLightPink,
    borderWidth: 0,
  },
  loadingContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  button: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: color => {
    if (color) {
      return {
        tintColor: color,
        marginRight: 8,
      }
    }
    return {
      marginRight: 8,
    }
  },
})
export const underlayColor = {
  primary: Colors.activeRed,
  secondary: Colors.activeGrey,
  tertiary: Colors.dark_grey,
  fall: Colors.blackRGBA(0.3),
  winter: 'rgba(24, 138, 180, 0.7)',
  light: Colors.veryLightPinkTwo,
  dark: Colors.thinDark,
}
